<template>
  <div>
    <div class="has-text-right">
      <sc-button
        type="button"
        theme="primary"
        text="Atualizar lista"
        @click="getFilesImport()" />
    </div>
    <br>
    <sc-table
      :data="files"
      default-sort="upload_date"
      default-sort-direction="desc"
      :per-page="pagination.limit"
      paginated>
      <template slot-scope="props">
        <sc-table-column
          field="file_name"
          label="Nome do Arquivo"
          sortable>
          {{ props.row.file_name }}
        </sc-table-column>

        <sc-table-column
          field="upload_date"
          label="Data de envio"
          sortable>
          {{ props.row.upload_date | date('DD/MM/YYYY - HH:mm:ss') }}
        </sc-table-column>

        <sc-table-column
          field="process_date"
          label="Data do processamento"
          sortable>
          {{ props.row.process_date | date('DD/MM/YYYY - HH:mm:ss') }}
        </sc-table-column>

        <sc-table-column
          field="process_status.value"
          label="Status do envio"
          sortable>
          <sc-status-file-import
            v-if="props.row.process_status && props.row.process_status.value"
            :status="props.row.process_status.value" />
        </sc-table-column>

        <sc-table-column
          field="download_url"
          label="Baixar arquivo">
          <sc-tooltip
            v-if="shouldShowTooltip(props.row.process_status)"
            :label="getFileStatusHelp(props.row.process_status && props.row.process_status.value)"
            class="sc-order-importer-table__tooltip"
            type="is-light"
            position="is-left">
            <a
              :href="props.row.download_url"
              :disabled="!props.row.download_url"
              class="button is-primary">
              Baixar Arquivo
            </a>
          </sc-tooltip>

          <template v-else>
            <a
              :href="props.row.download_url"
              :disabled="!props.row.download_url"
              class="button is-primary">
              Baixar Arquivo
            </a>
          </template>
        </sc-table-column>
      </template>

      <template slot="footer">
        <slot name="table-footer">
          <p v-if="totalFiles">
            <strong>Total de registros:</strong>
            <span>{{ totalFiles }}</span>
          </p>
        </slot>
      </template>

      <template slot="bottom-left">
        <sc-table-per-page v-model="pagination.limit" />
      </template>

      <template slot="empty">
        <sc-table-empty />
      </template>
    </sc-table>
  </div>
</template>

<script>
  import {
    ScButton,
    ScIcon,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScTablePerPage,
    ScTooltip,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  import ScStatusFileImport from '../sc-status-file-import/ScStatusFileImport';
  import importFileStatus from '../../enums/importFileStatus.enum';

  const {
    mapState,
    mapActions,
  } = createNamespacedHelpers('recon/xmlCteTags');

  export default {
    name: 'sc-file-import-table',
    data() {
      return {
        pagination: {
          page: 1,
          limit: 10,
        },
      };
    },
    computed: {
      ...mapState([
        'loading',
        'files',
      ]),
      totalFiles() {
        return this.files.length;
      },
    },
    methods: {
      ...mapActions([
        'getFilesImport',
      ]),
      shouldShowTooltip(status) {
        return status && status.value && this.getFileStatusHelp(status.value);
      },
      getFileStatusHelp(status) {
        const enumStatus = (status && importFileStatus[status]) ?
          importFileStatus[status] : null;

        return (enumStatus && enumStatus.help) ?
          enumStatus.help : null;
      },
    },
    mounted() {
      this.getFilesImport();
    },
    components: {
      ScButton,
      ScIcon,
      ScStatusFileImport,
      ScTable,
      ScTableColumn,
      ScTableEmpty,
      ScTablePerPage,
      ScTooltip,
    },
  };
</script>
<style lang="scss">
  .sc-file-import-table__tooltip {
    line-height: 1;
    padding: 2px 0;
    cursor: help;

    &:after {
      line-height: 1.2;
      white-space: pre;
      text-align: left;
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/components/sc-file-import-table/ScFileImportTable.vue